<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content rounded-4 shadow border-0">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-colonial">query_stats</span>
          Producción de {{ employee.name }} {{ employee.lastName }}
        </h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
      </div>

      <div class="modal-body">
        <p class="text-muted small mb-3">{{ roleLabel }}<ng-container *ngIf="employee.branchName"> · {{
            employee.branchName }}</ng-container></p>

        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border text-colonial" role="status"></div>
        </div>

        <div *ngIf="!loading && error" class="alert alert-warning mb-0" role="alert">{{ error }}</div>

        <ng-container *ngIf="!loading && stats">
          <div class="row g-3 mb-3">
            <div class="col-6">
              <div class="border rounded-3 p-3 text-center bg-light">
                <div class="fs-3 fw-bold text-colonial">{{ stats.quoteCount }}</div>
                <div class="small text-muted">Cotizaciones</div>
              </div>
            </div>
            <div class="col-6">
              <div class="border rounded-3 p-3 text-center bg-light">
                <div class="fs-3 fw-bold text-colonial">{{ stats.policyCount }}</div>
                <div class="small text-muted">Pólizas emitidas</div>
              </div>
            </div>
          </div>

          <p *ngIf="stats.products.length === 0" class="text-muted text-center small mb-0 py-2">
            Aún no tiene cotizaciones registradas.
          </p>

          <table *ngIf="stats.products.length > 0" class="table table-sm align-middle mb-0">
            <thead>
              <tr class="small text-muted">
                <th>Producto</th>
                <th class="text-end">Cotizaciones</th>
                <th class="text-end">Pólizas</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of stats.products">
                <td>{{ product.name }}</td>
                <td class="text-end">{{ product.quoteCount }}</td>
                <td class="text-end">{{ product.policyCount }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>
